import moment from 'moment';

export const formatDateWithoutTime = (date) => {
  return date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';
};

export const priceFormatter = (price) => {
  const convert = new Intl.NumberFormat('es-CL', {
    currency: 'CLP',
    style: 'currency',
  });
  return convert.format(price);
};
